import { request } from 'umi'
import { getToken } from '../../../functions/getValue'
import { Toast } from 'antd-mobile';
import { baseUrl } from '@/libs/config'
type method = 'POST' | undefined

interface RequestParams {
  uri?: string // 请求的api 会自动拼上baseUrl
  requestUrl?: string //请求url 若传了这个就不会走拼baseurl,请求链接等级最高，通常用于请求非baseurl外的链接
  params?: any //  请求参数
  method?: method // 请求方式 默认post
  options?: {
    headers?: any // 头部信息
    resolveData?: boolean // 失败的时候是否需要返回数据
  } // 请求的其他参数，比如拼上头部信息等
}

export interface RequestFn {
  <T>(params: RequestParams): Promise<T>
}

const requestApi: RequestFn = ({
  uri,
  params = {},
  method = 'POST',
  options = {},
}) => {
  const token = getToken('h5Token')
  // isChangeToken(uri)
  const {
    headers = {}, // 头部参数
  } = options || {}
  return new Promise(async (resolve, reject) => {
    // const url = uri
      // 创建FormData
    const formData = new FormData();
    // 添加额外数据
    Object.entries(params).forEach(([key, value]: [string, any]) => {
      if (value !== undefined && key !== 'lg') {
        console.log('typeof value ', typeof value )
        if (typeof value === 'object' && key !== 'image') {
          formData.append(key, JSON.stringify(value))
        } else {
          formData.append(key, value)
        }
      }
    })
    let url = uri
    request(url, {
      method,
      data: formData,
      headers: {
        ...headers,
        'h5-token': token,
        withCredentials: true,
        Accept: '*/*'
      },
      skipErrorHandler: true,
    })
      .then((res: any) => {
        const { code, msg } = res
        const isSuccess = code === 0
        if (isSuccess) {
          const resData = res.data
          resolve(resData)
        } else {
          Toast.show({
            content: res?.msg || '上传失败'
          })
          resolve(res)
        }
      })
      .catch((err: RequestResType) => reject(err))
      .finally(() => {})
  })
}

export default requestApi
